import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const PricingCard = ({
  plan,
  onSelect,
  disabled = false,
  disabledText,
  minWidth = '320px',
  maxWidth = '400px',
}) => {
  return (
    <Card
      sx={{
        flex: '0 1 auto',
        minWidth,
        maxWidth,
        boxShadow: plan.highlighted ? 4 : 1,
        border: plan.highlighted ? '2px solid' : 'none',
        borderColor: plan.highlighted ? 'accent.secondary' : 'transparent',
        position: 'relative',
        transition: 'all 0.3s',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {plan.highlighted && (
        <Box
          sx={{
            position: 'absolute',
            top: -3,
            left: '50%',
            transform: 'translateX(-50%)',
            bgcolor: 'accent.secondary',
            color: 'common.white',
            px: 2,
            py: 0.5,
            borderRadius: 1,
            fontWeight: 700,
            fontSize: '0.875rem',
            zIndex: 10,
          }}
        >
          MOST POPULAR
        </Box>
      )}
      <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%', pt: 4 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          {plan.name}
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          {plan.description}
        </Typography>
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              color: plan.highlighted ? 'accent.secondary' : 'inherit',
            }}
          >
            {plan.price}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            per {plan.period}
          </Typography>
        </Box>
        <List sx={{ flex: 1, mb: 2 }}>
          {plan.features.map((feature, fIdx) => (
            <ListItem key={fIdx} sx={{ py: 0.5, px: 0 }}>
              <ListItemIcon sx={{ minWidth: 32 }}>
                <CheckCircleIcon sx={{ fontSize: 20, color: plan.highlighted ? 'accent.secondary' : 'primary.main' }} />
              </ListItemIcon>
              <ListItemText
                primary={feature}
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
          ))}
        </List>
        <Button
          variant={plan.highlighted ? 'contained' : 'outlined'}
          fullWidth
          onClick={() => onSelect(plan.stripePriceId)}
          disabled={disabled}
          sx={{
            textTransform: 'none',
            fontSize: '1rem',
            ...(plan.highlighted && {
              bgcolor: 'accent.main',
              '&:hover': { bgcolor: 'accent.dark' },
            }),
          }}
        >
          {disabled && disabledText ? disabledText : plan.cta}
        </Button>
      </CardContent>
    </Card>
  );
};

export default PricingCard;
